/** Libraries */
import Swal from "sweetalert2";

/** Utils */
import Toast from "@moltech/molui/toast";

/** Encryption */
import { decryptAES } from "../encryption/CryptoService";

const ensureAuthStatusCode = (apiData, meta) => {
    if (apiData?.statusCode || !isAuthenticationUrl(meta)) return;

    const authFlag = apiData?.isAuthenticated ?? apiData?.responseItem?.responseContent?.isAuthenticated;
    if (authFlag !== undefined) {
        apiData.statusCode = authFlag ? 200 : 401;
    }
};

const isAuthenticationUrl = (meta) => meta.request.url.includes("Authentication");

const isSuccessResponse = (apiData) => {
    apiData.statusCode === 200 || Array.isArray(apiData);
    return true;
};

const handleAuthFailure = (apiData) => {
    const isAuth = apiData?.isAuthenticated ?? apiData?.responseItem?.responseContent?.isAuthenticated;
    const message = apiData?.message ?? apiData?.responseItem?.responseContent?.message;
    if (isAuth === false && message) {
        Toast.error(message);
        return false;
    }
    return true;
};

const extractResponseData = (apiData) => {
    if (apiData?.responseData?.data) {
        return {
            data: apiData.responseData.data,
            message: apiData.responseData.message,
            statusCode: apiData.responseData.statusCode,
            success: apiData.responseData.success,
        };
    }
    if (Array.isArray(apiData?.responseData)) {
        return apiData.responseData;
    }
    if (apiData?.responseData && typeof apiData.responseData === 'object') {
        return apiData.responseData;
    }
    return apiData;
};

export const transformSuccessResponse = async (response, meta) => {
    let resData = decryptAndParse(response);

    ensureAuthStatusCode(resData, meta);

    if (!isSuccessResponse(resData)) {
        Toast.error(resData.message || "Something went wrong with API. Please contact admin!!");
        return null;
    }

    if (isAuthenticationUrl(meta)) {
        const authCheck = handleAuthFailure(resData);
        if (!authCheck) return null;
    }

    const data = extractResponseData(resData);
    return data;
};

const normalizeError = (response) => {
    return {
        type: response?.status,
        statusCode:
            response?.data?.responseData?.statusCode ??
            response?.data?.statusCode ??
            response?.originalStatus ??
            (typeof response?.status === "number" ? response.status : null),

        data: response.data,
        raw: response
    };
};

const decryptAndParse = (data) => {    if (!data) return data;
    let res = data;
    if (res.isEnType) { res = decryptAES(res) };
    return typeof res === "string" ? JSON.parse(res) : res;
};

const handleValidationError = (resData) => {

    if (!resData?.errors) return;

    const shortenErrorMessage = (message) => {
        if (!message) return message;

        return message.split(" Path:")[0];
    };

    const errorListHtml = Object.entries(resData.errors)
        .map(([field, messages]) =>
            messages
                .map(msg => {
                    const cleanMsg = shortenErrorMessage(msg);
                    return `<li><strong>${field.replace(/^\$\./, "")}</strong>: ${cleanMsg}</li>`;
                })
                .join("")
        )
        .join("");

    Swal.fire({
        icon: "error",
        title: "Validation Error",
        html: `<ul style="text-align:left; padding-left:20px;">${errorListHtml}</ul>`,
        confirmButtonText: "OK"
    });
};


const handleHttpErrors = (statusCode, resData) => {
    switch (statusCode) {
        case 400:
            if (resData?.errors) handleValidationError(resData);
            return resData;

        case 401:
            Toast.error(resData?.message || "Unauthorized access. Please login again.");
            return null;

        case 500:
            Toast.error("Something went wrong with the API call! Please contact admin.");
            return null;

        default:
            return null;
    }
};

export const transformErrorResponse = (response, meta) => {
    const error = normalizeError(response);
    if (error.type === "FETCH_ERROR") {
        Toast.error("Oops! Error while fetching data from the server. Please try again later.");
        return null;
    };

    if (error.type === "PARSING_ERROR" && error.statusCode === 500) {

        const msg = response.data?.toLowerCase?.() || "";
        const isDbError = ["sql", "connection", "provider"].some(k => msg.includes(k));

        Toast.error(
            isDbError
                ? "Database connection issue. Please try again later."
                : "Invalid server response. Please try again later."
        );
        return null;
    };

    let apiData = decryptAndParse(error.data);

    if (apiData?.responseData) {
        apiData = apiData.responseData;
    }

    ensureAuthStatusCode(apiData, meta);

    if (error.statusCode && error.statusCode !== 200) {
        return handleHttpErrors(error.statusCode, apiData);
    }

    return null;

}